/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable eqeqeq */
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Button, Modal, Table } from 'antd';
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import * as SERVICE from '../../../constants/service.types';
import { NOTIFIES } from '../../../constants/system.keys';
import { openMessage, socketEmitEvent } from '../../../redux/actions';
import AddWhitelistIPComponent from '../Modals/AddWhitelistIP';

const { confirm } = Modal;

function getTimeFromMins(mins) {
  if (mins >= 1440 || mins < 0) {
    return 'NaN:NaN AM';
  }
  var h = (mins / 60) | 0,
    m = (mins % 60) | 0;
  return moment.utc().hours(h).minutes(m).format('hh:mm A');
}

const WhitelistIPTab = ({ namespace, isAdmin, isAuth, currentTab }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { whiteListIPs: listWhitelistIPs, deleteWhiteListIP } = useSelector(
    (state) => state,
  );

  const [whiteListIPs, setWhiteListIPs] = useState();
  const [visibleAddWhiteListIp, setVisibleAddWhiteListIp] = useState(false);
  const [keyWhiteListIP, setKeyWhiteListIP] = useState(Math.random());

  useEffect(() => {
    if (listWhitelistIPs) {
      setWhiteListIPs(
        listWhitelistIPs.map((ip, index) => ({
          ...ip,
          index: index + 1,
          loading: false,
        })),
      );
    }
    return () => {
      setWhiteListIPs(null);
    };
  }, [listWhitelistIPs]);

  useEffect(() => {
    if (isAuth === 1 && namespace && isAdmin) {
      let data = {
        namespace,
      };
      let dataObj = {
        appServiceType: SERVICE.LIST_WHITE_LIST_IP_BY_NAMESPACE,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      return dispatch(socketEmitEvent(dataObj));
    }
  }, [dispatch, isAdmin, isAuth, namespace]);

  useEffect(() => {
    if (deleteWhiteListIP) {
      const { data, message, result } = deleteWhiteListIP;
      const { ipAddress } = data;
      if (result === 1) {
        openMessage(NOTIFIES.SUCCESS, message);
        setWhiteListIPs((state) =>
          state.filter((ip) => ip.ipAddress !== ipAddress),
        );
      } else {
        openMessage(NOTIFIES.ERROR, message);
        setWhiteListIPs((state) =>
          state.map((ip) =>
            ip.ipAddress !== ipAddress ? ip : { ...ip, loading: false },
          ),
        );
      }
    }
  }, [deleteWhiteListIP]);

  const onAddWhitelistIp = (requestId, values) => {
    const { ipAddress, namespace, fromMinute, toMinute } = values;
    let data = {
      ipAddress,
      namespace,
      fromMinute,
      toMinute,
    };
    let dataObj = {
      appServiceType: SERVICE.ADD_WHITE_LIST_IP,
      requestId,
      body: JSON.stringify(data),
    };
    return dispatch(socketEmitEvent(dataObj));
  };

  const handleAddWhiteListIpDone = useCallback((data) => {
    setVisibleAddWhiteListIp(false);
    setKeyWhiteListIP(Math.random());
    return setWhiteListIPs((state) =>
      state && state.length > 0
        ? state.concat({
          index: state.length + 1,
          ipAddress: data.ipAddress,
          namespace: data.namespace,
          fromTime: data.fromMinute,
          toTime: data.toMinute,
          loading: false,
        })
        : [
          {
            index: 1,
            ipAddress: data.ipAddress,
            namespace: data.namespace,
            fromTime: data.fromMinute,
            toTime: data.toMinute,
            loading: false,
          },
        ],
    );
  }, []);

  const handleRemoveIp = (index, ipAddress, namespace) => {
    confirm({
      title: t('_REMOVE_IP_FROM_WHITELIST_TITLE', { ip: ipAddress }),
      icon: <ExclamationCircleOutlined />,
      okText: t('Remove'),
      onOk() {
        setWhiteListIPs((state) =>
          state.map((ip) =>
            ip.index !== index ? ip : { ...ip, loading: true },
          ),
        );
        let data = {
          ipAddress,
          namespace,
        };
        let dataObj = {
          appServiceType: SERVICE.DELETE_WHITE_LIST_IP,
          requestId: new Date().getTime(),
          body: JSON.stringify(data),
        };
        return dispatch(socketEmitEvent(dataObj));
      },
      onCancel() { },
    });
  };

  return (
    <Fragment>
      <Modal
        visible={visibleAddWhiteListIp}
        title={t('Add whitelist Ip')}
        onCancel={() => {
          setVisibleAddWhiteListIp(false);
          setKeyWhiteListIP(Math.random());
        }}
        footer={null}
      >
        {visibleAddWhiteListIp && (
          <AddWhitelistIPComponent
            key={keyWhiteListIP}
            namespace={namespace}
            onAdd={onAddWhitelistIp}
            onDone={handleAddWhiteListIpDone}
          />
        )}
      </Modal>

      {currentTab === 'white-list' && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            paddingBottom: '5px',
          }}
        >
          <Button onClick={() => setVisibleAddWhiteListIp(true)}>
            {t('Add whitelist Ip')}
          </Button>
        </div>
      )}
      <Table
        loading={!whiteListIPs}
        columns={[
          {
            title: t('Index'),
            dataIndex: 'index',
            key: 'id_ip',
          },
          {
            title: t('IP Address'),
            dataIndex: 'ipAddress',
            key: 'ipAddress_ip',
          },
          {
            title: t('Namespace'),
            dataIndex: 'namespace',
            key: 'namespace_ip',
          },
          {
            title: t('From'),
            dataIndex: 'fromTime',
            key: 'fromTime_ip',
            width: 200,
            render: (time) => getTimeFromMins(time),
          },
          {
            title: t('To'),
            dataIndex: 'toTime',
            key: 'toTime_ip',
            width: 200,
            render: (time) => getTimeFromMins(time),
          },
          {
            title: t('Action'),
            key: 'action-share-device',
            width: 120,
            render: (ip) => (
              <div className="manager-member-actions">
                <div
                  className="edit-button"
                  onClick={() =>
                    handleRemoveIp(ip.index, ip.ipAddress, ip.namespace)
                  }
                >
                  <DeleteOutlined /> {t('Remove')}
                </div>
              </div>
            ),
          },
        ]}
        dataSource={
          whiteListIPs &&
          whiteListIPs.map((ip) => ({
            ...ip,
            key: ip.index,
          }))
        }
      />
    </Fragment>
  );
};

export default WhitelistIPTab;
